import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '@app/components/base/base.component';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';
import { AuthService } from '@app/common/auth.service';
import {
  FinancialProductEnum,
  models,
  modelTypeEnum,
} from '@app/pages/quote/standard-quote/model/standard-quote.model';
import { ResponsiveService } from '@app/services/responsive.service';
import { coerceOpenQuoteBoolean, TaxType } from '@app/pages/quote/open-quote/model/open-quote.model';
import { environment } from '@env/environment.local';

// Cambio para merge
@Component({
  template: '',
})
export class HeaderDealOpenQuoteWrapper
  extends BaseComponent
  implements OnInit, OnChanges
{
  // Inputs
  @Input() deal: any;

  @Input() indexDeal: number;
  @Input() nameCompany: string;
  @Input() modeEdition: boolean;
  @Input() idQuote: number;
  @Input() userId: any;
  @Input() isValid: boolean;
  @Input() readOnlyActions = false;

  // Outputs
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() duplicate: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();

  @Output() addInsuranceOpen: EventEmitter<number> = new EventEmitter();
  @Output() editInsurance: EventEmitter<any> = new EventEmitter();
  @Output() deleteInsurance: EventEmitter<any> = new EventEmitter();
  @Output() isSelected: EventEmitter<any> = new EventEmitter();
  @Output() isSelectedInsurance: EventEmitter<any> = new EventEmitter();

  // Atributos
  isInsuranceEdition: boolean = false;

  add: boolean = false;
  isLoading: boolean = false;
  insuranceList: any;
  formInsuranceDeal: any;
  insuranceViewSelected: any;
  collapsed: boolean = true;
  models: models | undefined;
  financialProduct = FinancialProductEnum;

  // Service
  readonly responsive = inject(ResponsiveService);
  readonly financialCalculator = inject(FinancialCalculatorService);
  readonly authService = inject(AuthService);
  readonly featureLoyaltyFeriaQuotation = environment.featureLoyaltyFeriaQuotation;

  // Signals
  readonly menuRef = signal<string>('');

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['deal']) {
      this.insuranceList = this.deal.insuranceDeals;
    }
  }

  ngOnInit() {
    this.responsive.onListen();
  }

  /** Ícono Loyalty en listado de propuestas: open quote usa `dealIsLoyalty` por propuesta. */
  showDealLoyaltyBadge(deal: any): boolean {
    if (!this.featureLoyaltyFeriaQuotation || !deal) {
      return false;
    }
    return (
      coerceOpenQuoteBoolean(deal.dealIsLoyalty) ||
      coerceOpenQuoteBoolean(deal.loyaltyFinancialPackage)
    );
  }

  getId() {
    return 'menu-' + this.deal.id;
  }

  toggleMenuOptions(e: MouseEvent, updated: string = '') {
    e.preventDefault();
    this.menuRef.update((value) => (!!value ? '' : updated));
  }

  closeMenuOptions() {
    this.menuRef.set('');
  }

  update(index: number) {
    this.editInsurance.emit(index);
  }

  deleteSeguro(index: number) {
    this.deleteInsurance.emit(index);
  }

  addInsurance() {
    this.addInsuranceOpen.emit(-1);
  }

  selectedInsurance(event: any) {
    this.isSelectedInsurance.emit(event);
  }

  viewDeal(index: number) {
    const element = document.getElementById(`deal${index}`) as HTMLInputElement;
    element.classList.toggle('collapsed');
    this.collapsed = element.classList.contains('collapsed');
  }
  quoteUrl(deal: any) {
    if (!deal.profitDeal) return '*';
    return deal.profitDeal.urlQuote;
  }

  dealUrl(deal: any) {
    if (!deal.profitDeal) return '*';
    return deal.profitDeal.urlDeal;
  }

  canAddInsurance() {
    if (
      (this.deal.productType === modelTypeEnum.autobuses ||
        this.deal.productType === modelTypeEnum.tractos) &&
      this.deal.financialProductType == this.financialProduct.financialLeasing
    ) {
      return false;
    }
    return true;
  }

  getTaxFree(deal: any) {
    let taxValue = deal.taxFree || deal.taxFree == "true" ? true : false;
    if(this.nameCompany == "DTFS" && deal.financialProductType == FinancialProductEnum.directCredit) {
      taxValue = false;
    } else if(deal.financialProductType == FinancialProductEnum.financialLeasing || deal.financialProductType == FinancialProductEnum.pureLease) {
      taxValue = false;
    }
    return taxValue;
  }

  getPrice(deal: any) {
    const isPriceWithoutTax = this.getTaxFree(deal);
    if(isPriceWithoutTax) {
      return deal.unitPriceWithoutTax;
    } else {
      return deal.unitPriceWithTax;
    }
  }

  getDisaplayPrice(deal: any) {
    const isPriceWithoutTax = this.getTaxFree(deal);
    if(!isPriceWithoutTax) {
      return "Precio c/IVA";
    } else {
      return "Precio s/IVA";
    }
  }

  getTotalPrice(deal: any) {
    let downPayment = deal.downPayment;
    const isPureLease = deal.financialProductType === 'PURE_LEASING';
    let price = isPureLease ? this.getPrice(deal) : deal.unitPriceWithoutTax;
    if(isPureLease) {
      downPayment = 0;
    }
    return deal.quantity * (price - downPayment)
  }

  get insuranceAmount() {
    return this.deal?.insurance?.packageList?.amount ? this.deal?.insurance?.packageList?.amount : 0;
  }

  get hasMarshInsurance() {
    return (this.deal?.insurance) ? true : false;
  }

  get hasMarshInsuranceNotCalculated() {
    return this.deal?.insurance && this.deal?.insurance?.insuranceId == null;
  }

}
